import { InstallChapter, SendEventsChapter, IdentifyUsersChapter, EstimatingUsageChapter } from 'components/GettingStarted/Chapter';
import SignupLink from 'components/SignupLink';
import * as React from 'react';
export default {
  InstallChapter,
  SendEventsChapter,
  IdentifyUsersChapter,
  EstimatingUsageChapter,
  SignupLink,
  React
};